<template>
    <div class="newsCenter-con1" style="background-color: #f4f5f6;">
        ddddddddddddddddddddd
        <div class="newsCen_swiper1" >
            <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide>
                    <div class="x-cooper" :class="activeNewsIndex==4?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(4)">
                        <a class="pic" target="_blank" href="http://www.jingebm.com/"><img  src="../assets/bg_sh.png" alt="" /></a>
                    </div>
                    <div class="x-cooper" :class="activeNewsIndex==5?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(5)">
                     <a class="pic" target="_blank" href="https://www.aramark.cn/"><img src="../assets/bg_aima.png" alt="" /></a>
                    </div>
                </swiper-slide> 
                <swiper-slide>
                    <div class="x-cooper" :class="activeNewsIndex==6?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(6)">
                        <a class="pic" target="_blank" href="http://www.kangou.cn"><img src="../assets/bg_kangou.png" alt="" /></a>
                    </div>
                    <div class="x-cooper" :class="activeNewsIndex==7?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(7)">
                        <a class="pic" target="_blank" href="http://www.gzxyh.com/"><img src="../assets/databg.png" alt="" /></a>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="x-cooper" :class="activeNewsIndex==8?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(8)">
                        <a class="pic" target="_blank" href="http://www.hot-spot.com.cn/"><img src="../assets/bg-hetebao.png" alt="" /></a>
                      </div>
                      <div class="x-cooper" :class="activeNewsIndex==9?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(9)">
                        <a class="pic" target="_blank" href="http://www.yuezhenxiaochu.com/"><img src="../assets/bg-yuezhenxiaochu.png" alt="" /></a>
                      </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="x-cooper" :class="activeNewsIndex==10?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(10)">
                        <a class="pic" target="_blank" href="http://www.shlscy.com/index.asp"><img src="../assets/longshen.jpg" alt="" /></a>
                      </div>
                      <div class="x-cooper" :class="activeNewsIndex==11?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(11)">
                        <a class="pic" target="_blank" href="http://zhendatuanshan.com/"><img src="../assets/zhenda.jpg" alt="" /></a>
                      </div>
                </swiper-slide> 
                <swiper-slide>
                    <div class="x-cooper" :class="activeNewsIndex==12?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(12)">
                        <a class="pic" target="_blank" href="https://www.quicklygroup.com.cn/"><img src="../assets/kuaikeli.jpg" alt="" /></a>
                      </div>
                      <div class="x-cooper" :class="activeNewsIndex==13?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(13)">
                        <a class="pic" target="_blank" href="http://www.debo-cn.com/"><img src="../assets/dengbao.jpg" alt="" /></a>
                      </div>
                 </swiper-slide>
                <swiper-slide>
                    <div class="x-cooper" :class="activeNewsIndex==14?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(14)">
                        <a class="pic" target="_blank" href="	https://www.zsxtc.com/"><img src="../assets/zhongshan.jpg" alt="" /></a>
                    </div>
                    <div class="x-cooper" :class="activeNewsIndex==15?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(15)">
                        <a class="pic" target="_blank" href="https://www.tuanshan365.com/"><img src="../assets/lixinniannian.jpg" alt="" /></a>
                    </div>
                </swiper-slide>
        
                <div class="swiper-pagination" slot="pagination"></div>
          </swiper>  
        </div>
    </div> 
</template>
        
<script>
// import 'swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
export default{
    components: {swiper, swiperSlide},
    data() {
        return {
            swiperOption: {
                direction: 'horizontal',
                height : window.innerHeight,
                spaceBetween: 0,
                slidesPerView:4,
                // centeredSlides: true,
                loop:false,
                // loopAdditionalSlides:3,
                autoplay: {
                    delay: 300000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination',
                    direction: 'orizontal',
                    clickable: true
                }
                // navigation: {
                //     nextEl: '.swiper-button-next',
                //     prevEl: '.swiper-button-prev'
                // }
            },
            img_height:'',
            img_width:'',
            url_back_img: {
               
            },
            activeNewsIndex:''
        }
    },
    computed:{
        swiper() {
            return this.$refs.mySwiper.swiper
        }
    },
    
  methods:{
    onMouseLeaveNews() {
      this.activeNewsIndex = -1;
    },

    onMouseEnterNews(val) {

      this.activeNewsIndex = val;
      console.log(this.activeNewsIndex,"<<<<<<")
    },
   
  }
}
</script>
<style >
    .poster{
        /* background: url(./../assets/img/pg1-bg.png); */
        width: 100%; 
        height: 100%; 
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        zoom: 1; 
    }  
    .swiper-container {
        width: 100%;
        height: 100%;
        margin-left: auto;
        margin-right: auto;
    }
    .newsCen_swiper1{
        /* position: fixed; */
        z-index: 1;
        overflow: hidden;
        width: 90%;
        height: 100%; 
        color:red;
        margin-top:200px;
        margin:0 auto;
     } 
     .x-cooper img{
         width: 100%;
         height: 100%;
     }
     .x-cooper {
    border: 1px solid transparent;
    margin-bottom: 10px;
    margin-right: 10px;
}
.x-cooper.is-active{
    margin-bottom: 10px;
    margin-right: 10px;
  border: 1px solid #83C0FB;
  box-shadow:0px 0px  10px 1px rgba(168,168,168,0.5);
  -moz-box-shadow:0px 0px  10px 1px rgba(168,168,168,0.5);
  -webkit-box-shadow:0px 0px  10px 1px rgba(168,168,168,0.5);
}
</style>
    


// WEBPACK FOOTER //
// src/components/test.vue